<template>
  <div>
    <Header/>
    <div class="operatingContent">
      <div class="tab">
        <div class="tabmenu" v-if="$route.meta.parent !=='operatingFloor'">
          <router-link to="/operatingFloor/collection" class="icon1">下单收银</router-link>
        </div>
        <div class="tabmenu" v-else>
          <router-link to="/operatingFloor/openOrder" class="icon6">返回操作台</router-link>
        </div>
        <div class="tabmenu">
          <a href="javascript:;" class="icon2" @click="openService">服务开单</a>
        </div>
        <div class="tabmenu">
          <a href="javascript:;" class="icon3" @click="reservation">预约服务</a>
        </div>
        <div class="tabmenu">
          <a href="javascript:;" class="icon3" @click="toMem">会员登记</a>
        </div>
        <div class="tabmenu">
          <a href="javascript:;" class="icon5" @click="recharge">充值</a>
        </div>
      </div>
      <div class="opreaCont">
        <keep-alive include="collection">
          <router-view :memsInfo="memInfotel" :refreshFlag="refreshFlag"/>
        </keep-alive>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="dialogType === 1 ? '服务开单':(dialogType === 2 ? '预约服务':(dialogType === 3 ? '创建会员':(dialogType === 4 ?'会员充值':'支付方式')))" class="dialogVisible" :visible.sync="dialogTableVisible" :center="true" width="600px">
        <operating :dialogType="dialogType" @closeDialog="closeDialog" @cancelDialog="cancelDialog" @memInfo="memInfos" @refresh="refresh" :dialogTableVisible="dialogTableVisible"/>
    </el-dialog>
    <el-dialog class="dialogVisible" :visible.sync="dialogSetpwd" :center="true" width="800px">
        <setPwd :setpayPwd="setpayPwd" :dialogSetpwd="dialogSetpwd" @closeset="closeset"/>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Header from "@/components/common/Header";
import operating from './operating';
import setPwd from '@/components/basicDataCenter/setPsd'

export default {
  components: {
    Header, operating, setPwd
  },
  data() {
    return {
      dialogType:'',
      dialogTableVisible:false,
      memInfotel:'',
      refreshFlag:false,
      dialogSetpwd:false,//设置消费密码弹框
      setpayPwd:'',//设置密码标识，是否加入会员
    };
  },

  methods: {
    openService(){
      // 服务开单
      this.dialogTableVisible = true;
      this.dialogType = 1;
    },
    reservation() {
      // 预约服务
      this.dialogTableVisible = true;
      this.dialogType = 2;
    },
    recharge(){
      // 充值
      this.dialogTableVisible = true;
      this.dialogType = 4;
    },
    closeDialog(val){
      if(val == 'payClick'){
        this.dialogType = 5;
      }else{
        this.dialogTableVisible = val;
      }
    },
    memInfos(val){
      this.memInfotel = val;
    },
    toMem(){
      // this.$router.push("/basicDataCenter");
      this.dialogTableVisible = true;
      this.dialogType = 3;
    },
    refresh(){
      this.refreshFlag = !this.refreshFlag;
    },
    cancelDialog(val){
      this.dialogTableVisible = false;
      this.dialogSetpwd = true;
      this.setpayPwd = val;
    },
    closeset(val){
      this.dialogSetpwd = val;
      this.dialogTableVisible = true;
      this.dialogType = 1;
    },
  }
};
</script>
<style lang="less" scoped>
.operatingContent {
  width: 100%;
  .tab {
    width: 630px;
    margin: 15px auto;
    overflow: hidden;
    .tabmenu {
      width: 90px;
      height: 90px;
      float: left;
      margin-right: 45px;
      &:last-child{
        margin-right: 0;
      }
      a {
        display: block;
        color: #898f9b;
        font-size: 12px;
        cursor: pointer;
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 90px;
        padding-top: 10px;
        border: 7px solid #c4cbe1;
        border-radius: 50%;
        &.icon1 {
          background: url(../../assets/images/store/btn_console_cash.png)
            no-repeat center 8px;
          background-size: 40px auto;
        }
        &.icon2 {
          background: url(../../assets/images/store/btn_console_order.png)
            no-repeat center 8px;
          background-size: 40px auto;
        }
        &.icon3 {
          background: url(../../assets/images/store/btn_console_reserve.png)
            no-repeat center 8px;
          background-size: 40px auto;
        }
        &.icon4 {
          background: url(../../assets/images/store/btn_console_member.png)
            no-repeat center 8px;
          background-size: 40px auto;
        }
        &.icon5 {
          background: url(../../assets/images/store/btn_console_recharge.png)
            no-repeat center 8px;
          background-size: 40px auto;
        }
        &.icon6 {
          background: url(../../assets/images/store/back.png) no-repeat center
            6px;
          background-size: 40px auto;
        }
        &:hover,
        &.router-link-active {
          color: #f96479;
          border: 7px solid #f6cfd7;
          &.icon1 {
            background: url(../../assets/images/store/btn_console_cash_hover.png)
              no-repeat center 8px;
            background-size: 40px auto;
          }
          &.icon2 {
            background: url(../../assets/images/store/btn_console_order_hover.png)
              no-repeat center 8px;
            background-size: 40px auto;
          }
          &.icon3 {
            background: url(../../assets/images/store/btn_console_reserve_hover.png)
              no-repeat center 8px;
            background-size: 40px auto;
          }
          &.icon4 {
            background: url(../../assets/images/store/btn_console_member_hover.png)
              no-repeat center 8px;
            background-size: 40px auto;
          }
          &.icon5 {
            background: url(../../assets/images/store/btn_console_recharge_hover.png)
              no-repeat center 8px;
            background-size: 40px auto;
          }
          &.icon6 {
            background: url(../../assets/images/store/back_hover.png) no-repeat
              center 6px;
            background-size: 40px auto;
          }
        }
      }
    }
  }
  .opreaCont {
    width: 100%;
    min-height: 700px;
    overflow-x: auto;
    overflow-y: hidden;
    background: #fff;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/operatingFloor/operatingFloor.vue